<template>
  <div class="item-inner specal">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >
      <span v-if="attribute.columnName === 'TVInfo.usageID' || attribute.columnName === 'TVInfo2.usageID'">载体用途说明</span>
      <span v-else>{{this.attribute.label}}</span></div>
    <div class="item-title label" v-else style="width: 60%;">
      <span v-if="attribute.columnName === 'TVInfo.usageID' || attribute.columnName === 'TVInfo2.usageID'">载体用途说明</span>
      <span v-else>{{this.attribute.label}}</span>
      <a class="alert-text" @click="showMessage(attribute)" v-if="attribute.columnName === 'ExpressionTest' || attribute.columnName === 'InducingTest' || attribute.columnName === 'LVAmount'  || attribute.columnName === 'NC_LV_Amount'">
        <img :src="questionUrl" style="width: .9rem"></img>
      </a>
      <a class="alert-text" @click="displayMessage(attribute.description)" v-if="attribute.description">
        <img :src="questionUrl" style="width: .9rem"></img>
      </a>
    </div>
    <div class="item-after guding" style="border:0px solid #e7e7e7;margin-bottom: 3rem"  v-if="(attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20) && attribute.valueText.length >= 50 " >
      <div class="item-input">
        <textarea style="font-size: .6rem;text-align: center "  placeholder="请选择"  :value='attribute.valueText' readonly="readonly"></textarea>
      </div>
    </div>
    <div class="item-after guding" style="border:0px solid #e7e7e7"  v-else-if="(attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20) && attribute.valueText.length >= 12 && attribute.valueText.length <50 " >
      <div class="item-input">
        <textarea style="font-size: .6rem;text-align: center "  placeholder="请选择"  :value='attribute.valueText' readonly="readonly"></textarea>
    </div>
    </div>
    <div class="item-after guding" style="border:1px solid #e7e7e7"  v-else-if="(attribute.sorteditAble === false || attribute.groupId === 1 || merchandises.categoryId !== 20) && attribute.valueText.length < 12" >
      <div class="item-input">
        <input type="text" style="font-size: .6rem;text-align: center "  placeholder="请选择"  :value='attribute.valueText'  readonly="readonly">
      </div>
    </div>
    <div class="item-after guding" style="border:1px solid #e7e7e7" v-else @click="showOptionList(attribute)">
      <div class="item-input">
        <input type="text" style="font-size: .6rem;text-align: center; "  placeholder="请选择"    v-model="attribute.valueText"  readonly  unselectable="on">
      </div>
      <span class="icon icon-down" style="margin-top:.2rem;margin-right: .5rem;color: gray " disabled="disabled"></span>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Emkt from '../../../emkt'
  export default {
    name: 'finder-attr-enum-box',
    data () {
      return {
        checkedData: '',
        questionUrl: '/emktResources/resocurces/img/question.png',
        attrurl: '../../../static/filters/'
      }
    },
    props: [
      'attribute', 'index', 'attributesList', 'merchandises', 'type', 'param'
    ],
    mounted () {
    },
    created () {
      this.fetchData()
    },
    computed: {
      options () {
        let opt = this.attribute.options
        let resArr = []
        if (opt) {
          for (var data in opt) {
            console.log(data)
          }
          return resArr
        }
        return resArr
      }
    },
    methods: {
      fetchData () {
        if (this.type) {
          return
        }
        var opt = this.attribute.options
        if (opt && this.attribute.groupId === 3 && this.attribute.sectionId === 2) {
          var obj = {}
          if (this.merchandises.specAttributes && this.merchandises.specAttributes[this.attribute.columnName]) {
            for (var data in this.merchandises.specAttributes[this.attribute.columnName]) {
              if (this.attribute.columnName === 'AAVBloodType') {
                obj = Emkt.getLocalStorage('SpecialBloodOptions')
              } else {
                for (var data2 in this.attribute.options) {
                  if (this.merchandises.specAttributes[this.attribute.columnName][data].toString() === data2) {
                    obj[data2] = this.attribute.options[data2]
                  }
                }
              }
            }
          }
          this.attribute.options = obj
//          if (this.attribute.columnName === 'LVAmount' && this.merchandises._attributes.NC_LV_Amount) {
//            this.merchandises._attributes.NC_LV_Amount.options = obj
//          }
//          if (this.attribute.columnName !== 'NC_LV_Amount') {
//            this.attribute.options = obj
//          } else {
//            this.attribute.options = this.merchandises._attributes.LVAmount.options
//          }
        }
//        if (this.merchandises.categoryId === 20 && this.attribute.groupId === 3 && this.param === undefined) {
//          this.attribute.value = ''
//        }
      },
      showMessage (attribute) {
        var name = ''
        if (attribute.columnName === 'ExpressionTest') {
          name = 'ExpressionTest.jpg'
        } else if (attribute.columnName === 'InducingTest') {
          name = 'InducingTest.jpg'
        } else if (attribute.columnName === 'LVAmount' || attribute.columnName === 'NC_LV_Amount') {
          name = 'LVAmount.jpg'
        }
        var content = '<div id="lottery"><img style="width: 100%;height: 100%;"' + 'src=' + this.attrurl + name + '></div>'
        $.modal({
          text: content,
          buttons: [ {
            text: '确定',
            onClick: function () {
            }
          }]
        })
        $('.modal').css({'width': '17rem', 'height': '100%', 'margin-left': '-8.7rem'})
        $('.modal-buttons').css({'height': '1.5rem'})
        $('.modal-button').css({'line-height': '1.5rem'})
        $('.modal-inner').css({'padding': '0rem'})
      },
      getAfterText (attribute) {
        var ret1 = '<li class="item-content item-link" ><label class="label-checkbox item-content">' +
          '<input type="radio"  class="radio-input-attr" name="attr" value="'
        var ret2 = ''
        var ret3 = '"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        var ret4 = '" checked="checked"><div class="item-media" style="margin-left: -1rem;font-size: .7rem"><i class="icon icon-form-checkbox i-style" style=" margin-right: 0.5rem;"></i><div style="width: 9.5rem; word-wrap:break-word;text-align: left;">'
        let attr = this.attribute.options
        let height = ''
        var length = 0
        for (var key in attr) {
          if (attribute.valueText === attr[key]) {
            ret2 += ret1 + key + ret4 + attr[key] + '</div></div></label></li>'
          } else {
            ret2 += ret1 + key + ret3 + attr[key] + '</div></div></label></li>'
          }
          length++
        }
        var ret
        if (length <= 7) {
          height = 2.1 * length + 1
          ret = '<div class="modal-class" style="height: ' + height + 'rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        } else {
          ret = '<div class="modal-class" style="height: 12rem;overflow-y: scroll; display: flex"><div class="list-block" style="margin: auto;"><ul style="border-radius: 0.3rem;background-color: #E9E9E9;">'
        }
        ret = ret + ret2 + '</ul></div></div>'
        return ret
      },
      displayMessage (val) {
        if (!val) {
          return
        }
        $.alert(val)
      },
      getTitle (attribute) {
        var data = '<div class="modal-title" style="font-size: .7rem">' + attribute.label + '</div>'
        return data
      },
      showOptionList (attribute) {
        let _this = this
        $.modal({
          title: _this.getTitle(attribute),
          afterText: _this.getAfterText(attribute),
          buttons: [
            {
              text: '取消',
              bold: true,
              onClick: function () {
                if (_this.checkedData) {
                  _this.attribute.value = _this.checkedData
                }
              }
            }
          ]
        })
        var obj1 = document.getElementById('modal-title')
        if (obj1 !== null) {
          obj1.style.cssText = 'font-size: .6rem;'
        }
        $('.radio-input-attr').on('click', function () {
          let val
          let radio = $('.radio-input-attr')
          for (var i = 0; i < radio.length; i++) {
            if (radio[i].checked) {
              val = radio[i].value
            }
          }
          if (_this.attribute.value !== val) {
            _this.attribute.value = val
            _this.checkedData = val
            _this.valueChanged(attribute)
          }
          $.closeModal()
        })
      },
      valueChanged (attribute) {
        this.$emit('controlForm', this.index, attribute)
//        this.$emit('judgeValue', this.curAttrsInGroup, this.index)
      }
//      ,
//      getKeyByValue (value) {
//        let obj = this.attribute.options
//        for (var prop in obj) {
//          if (obj.hasOwnProperty(prop)) {
//            if (obj[prop] === value) {
//              return prop
//            }
//          }
//        }
//      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.valueText = this.attribute.options[val]
        this.$emit('controlForm', this.index, this.attribute)
//        this.merchandises._attributesList = this.attributesList
//        this.$emit('controlForm', this.index, this.merchandises)
//        if (!this.$route.query.cust) {
//          this.$emit('controlForm', this.index, this.curAttrsInGroup, this.attribute)
//        }
      }
//      ,
//      attribute: {
//        handler: function (val) {
//          this.attribute.value = this.getKeyByValue(val)
//        },
//        deep: true
//      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }
  .modal-class{
    width: 12rem;
    height: 15rem;
    margin-top: 1rem;
    margin-left: -3rem;
  }
  .specal {
    border-bottom: 0px solid;
  }
  .checkbox-el {
    display: inline-block;
    text-align: left;
  }
  .options {
    color: grey;
    font-size: .6rem;
    width: 120px;
    margin-left: .3rem;
  }
  .item-content {
    padding-left: .2rem
  }
  .item-title {
    font-size: 0.6rem;
    color: black;
  }
  .guding {
    width: 140px;
  }
  .item-after {
    font-size: 0.6rem;
    color: black;
  }

  .gotopay{
    position: absolute;
    right: 0;
    background-color: #00469A;
  @include wh(5rem, 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 5rem;
    height: 3rem;}
  .gotopay_button_style{
  @include sc(.7rem, #F6383A);
    font-weight: bold;
    color: #fff;

  }
  .button.active {
    z-index: 100;
    color: #00469A;
    background-color: white;
    border-bottom: 1px solid
  }
  .tab-link.button {
    border: 0px solid black;
    color: gray;
    border-radius: 0;
  }
  input::-webkit-input-placeholder{
    color:rgb(8, 148, 236);
  }
</style>



// WEBPACK FOOTER //
// FinderAttrEnumBox.vue?467dd3d0